const M = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAgMmEyIDIgMCAwIDEgMiAydjEzLjQxNEwxNy40MTQgMjJINGEyIDIgMCAwIDEtMi0yVjRhMiAyIDAgMCAxIDItMmgxNnptMCAySDR2MTZsMTEtLjAwMVYxN2EyIDIgMCAwIDEgMi0yaDNWNHptLS40MTUgMTNIMTd2Mi41ODRMMTkuNTg1IDE3ek0xMyAxNXYySDd2LTJoNnptNC00djJIN3YtMmgxMHptMC00djJIN1Y3aDEweiIgZmlsbC1ydWxlPSJldmVub2RkIi8+PC9zdmc+Cg==";
export {
  M as default
};
//# sourceMappingURL=note-cc24b531.mjs.map
